<template>

  <!--    <loading-block v-if="!is_load" :loading="!is_load"/>-->
  <div>
    <!--    <loading-block v-if="!is_load" :loading="!is_load"/>-->
    <nav v-if="is_load"   class="main_desktop_navbar navbar main_top_nav  d-none d-sm-none d-md-block   bg-light">
      <div class="container justify-content-start no_padding_right no-gutters">
        <div class="col-md-3  col-lg-3 col-sm-6 col-6 ">

          <a class="navbar-brand navbar-apper-brand w-100" v-if="is_load && current_theme=='day_mode' && (url_logotype && url_logotype.length>0)" href="/"><img class="img-fluid" :src="url_logotype"></a>
          <a class="navbar-brand navbar-apper-brand w-100" v-if="is_load && current_theme=='night_mode' && (url_logotype_dark && url_logotype_dark.length>0)" href="/"><img class="img-fluid" :src="url_logotype_dark"></a>

        </div>


        <div class="col-md-9  col-lg-8  upper_main_bar mainnavbar meganav_base_double">
          <ul v-if="ismarketplace==false" class=" navbar-nav mr-auto uppernavbar ">

            <li v-bind:class="{ active: typebar=='link_'+main_link.id, notactive:typebar!='link_'+main_link.id }" :title="main_link.alt" class="nav-item" v-if="main_links.length>0" v-for="(main_link,main_link_key) in main_links" :key="main_link_key" >
              <a href="javascript:void(0);"  @click="changeSubbar('link_'+main_link.id,main_link_key)" class="nav-link d-flex   upper_menu_li">
                <span class="menu_icon"   v-html="main_link.icon"></span>

                <span class="menu_title my-auto" v-bind:class="{'login_title_class':(main_link.id=='login')}" v-if="main_link.type!='/setup'" v-html="main_link.title"></span>
                <span class="menu_title my-auto" v-if="main_link.type=='/setup'"><badge v-if="total_count>0"
                    type="info">{{
                    total_count
                  }}</badge></span>

              </a>

            </li>



          </ul>
          <ul v-if="ismarketplace==true" class=" upper_navbar navbar-nav mr-auto uppernavbar ">

            <li v-bind:class="{ 'cart_li_desktop':main_link.type=='/cart',active: typebar=='link_'+main_link.id, notactive:typebar!='link_'+main_link.id }" :title="main_link.alt" class="nav-item" v-if="main_links.length>0" v-for="(main_link,main_link_key) in main_links" :key="main_link_key" >
              <a href="javascript:void(0);" :class="{'cart_menu flex-column':main_link.type=='/cart'}" @click="changeSubbar('link_'+main_link.id,main_link_key)" class="nav-link d-flex   upper_menu_li">
                <span class="menu_icon"   v-html="main_link.icon"></span>

                <span class="menu_title my-auto"  v-bind:class="{'login_title_class':(main_link.id=='login')}" v-if="main_link.type!='/cart' && main_link.type!='/setup'" v-html="main_link.title"></span>
                <span class="menu_title my-auto" v-if="main_link.type=='/cart'"><span v-if="cart && cart.length>0" class="badge badge-info">{{ cart.length}}</span></span>
                <span class="menu_title my-auto" v-if="main_link.type=='/setup'"><badge v-if="total_count>0"
                    type="info">{{
                    total_count
                  }}</badge></span>
              </a>

            </li>



          </ul>
        </div>
      </div>




      <div class="row container justify-content-start subnav_blocks_row">
        <div class="col-md-4  col-lg-3 col-sm-6 col-6 ">
        </div>
        <div class="col-md-8  col-lg-6">
          <div class=" w-100 "  v-if="is_load && main_links.length>0 && main_link.links && main_link.links.length>0 && typebar=='link_'+main_link.id" v-for="(main_link,main_link_key) in main_links" :key="'div_'+main_link_key">

            <div class="d-flex justify-content-center w-100  subnav_block ml-4" v-if="main_link.links && main_link.links.length>1">
              <router-link :data-id="sub_link.id" :title="sub_link.alt" :class="{active:((subbar_active_link_href==sub_link.type)),not_active:!((subbar_active_link_href==sub_link.type))}" tag="a" :to="sub_link.type" @click.native="openSubMenuLink(sub_link.type)" v-for="(sub_link,sub_link_key) in main_link.links" :key="'sublink_'+sub_link.id"   >
                {{sub_link.title}}
                <b v-if="sub_link.type=='/leadtasks'"><badge v-if="notify_count_tasks>0"
                    type="danger">{{
                    notify_count_tasks
                  }}</badge></b>
              </router-link>
            </div>
          </div>

        </div>
      </div>
    </nav>
    <div class="upper_subbar_mobile d-block main_mobile_logo_div d-sm-block d-md-none">
    <div class="row fixed-top upper_subbar_mobile mobile_logo_block d-block d-sm-block d-md-none" v-if="is_load_mobile">
      <div class=" col-sm-6 col-6 float-left ">

        <a class="ml-2 navbar-brand navbar-apper-brand w-100" @click="openHome()"  v-if="is_load_mobile && current_theme=='day_mode' && (url_logotype && url_logotype.length>0)" href="javascript:void()"><img class="img-fluid" :src="url_logotype"></a>
        <a class="ml-2 navbar-brand navbar-apper-brand w-100" @click="openHome()" v-if="is_load_mobile && current_theme=='night_mode' && (url_logotype_dark && url_logotype_dark.length>0)" href="javascript:void()"><img class="img-fluid" :src="url_logotype_dark"></a>

      </div>
      <div class="col-sm-4 col-4 float-right">
        <router-link v-if="islogin==true" tag="a" :class="{'btn btn-second_setting_page':((isSettigPage())),'btn':!((isSettigPage()))}" class="mb-2 btn_no_padding nav_link  float-right mr-2  btn-lg" :to="{path:'/setup'}"><span class="menu_icon">&nbsp;<i class="fa fa-cog"></i>&nbsp;<badge v-if="total_count>0"
            type="info">{{
            total_count
          }}</badge> </span></router-link>
        <router-link v-if="islogin==false" tag="a" :class="{'btn btn-second_setting_page':((isLoginPage())),'btn':!((isLoginPage()))}" class="mb-2 btn_no_padding nav_link float-right mr-2   btn-lg" :to="{path:getLoginLink()}"><span class="menu_icon"><i class="fa fa-user"></i></span></router-link>

      </div>
    </div>
    <div class="col-12 fixed-top upper_subbar_mobile after_mobile_logo" v-if="footer_active_load && footer_links && footer_links.length>1">
      <ul class="nav justify-content-center widget_nav">
        <li class="nav-item" v-for="(main_link,main_link_key) in footer_links" >
          <router-link tag="a" class="nav_link " :class="{'active':main_link.id==footer_active_id}"
              :to="main_link.type">{{ main_link.title}}</router-link>

        </li>


      </ul>
    </div>
    </div>
    <div class="col-12 upper_subbar_mobile_after" v-if="footer_active_load">&nbsp;</div>
    <div class="alert" v-if="is_load && islogin==true && $route.query && $route.query.after_login=='show' && is_show_after_login==true">
      <h2>Вы успешно авторизовались!</h2>
      <button class="btn" @click="closeAfterLogin">Закрыть</button>
    </div>

  </div>
</template>
<script>
import BaseNav from "@/components/BaseNav";
import BaseDropdown from "@/components/BaseDropdown";
import BaseNotifyDropdown from "@/components/BaseNotifyDropdown";
import CloseButton from "@/components/CloseButton";
import {vueTelegramLogin} from 'vue-telegram-login'
import axios from 'axios';
import {eventBus} from '../main.js';
import Vue from "vue";
import Api from "../models/Api";
import {vm} from "../main.js";
import Modal from "@/components/Modal";
import LoginModal from "../components/LoginModal";
import Avatar from 'vue-avatar'
import UserModel from "../models/UserModel";
import LogoComponent from "@/components/Custom/LogoComponent";
import LoadingBlock from "../components/Custom/LoadingBlock";


require('dotenv').config()

export default {

  components: {
    LoadingBlock,
    Modal,
    BaseNav,
    CloseButton,
    BaseDropdown,
    BaseNotifyDropdown,
    vueTelegramLogin,
    LoginModal,
    Avatar,
    "LogoComponent":LogoComponent,

  },


  data: function () {

    return {
      windowWidth: window.innerWidth,
      'is_show_after_login':true,
      'typebar':'',
      'nextURL':'',
      'url_logotype':null,
      'url_logotype_dark':null,
      'subbar_active_link':'',
      'subbar_active_link_href':'',
      'cart':[],
      'total_count':0,
      'pages_categorys':[],
      'categorys_blog':{},
      loaded_blog_category:false,
      "telegram_bot": null,
      is_disable_editor:false,
      user: {},
      test_user:{},
      is_load_pages: false,
      pages: [],
      random_code: '',
      funnels:[],
      'main_links':[],
      "current_theme":"day_mode",
      is_notify_load: false,
      new_task_developer: null,
      "loaded_categorys": false,
      "categorys": null,
      "notifys": null,
      "notify": {
        "show_only_unread": true,
      },
      'modal_params': {},
      "modals": {
        "add_project": null,
      },
      "notify_counts": {
        "projects": 0,
        "freelance": 0,
        "comments": 0,
        "invoices": 0,
      },
      "modal_add_title": "Размещение проекта",
      "is_show_category": true,
      "is_add_task": false,
      "iserror": false,
      "error_message": null,
      "modal_btn_add_project": "Отправить на оценку",
      "form": {
        'category': null,
        'json': {},
        'fields':{},
      },
      "config": {},
      'ismarketplace':false,
      notify_count: 0,
      notify_count_invoices:0,
      notify_count_tasks:0,
      'is_load_mobile':false,
      islogin: false,
      'istgbot': false,
      'timer': '',
      'timer_check_code': '',
      show_modal_after_login: true,
      'slogans':[],
      "total_cart_price":0,
      'is_load':false,
      'title_site':'',
      'update_notify_interval':null,
      'current_meta':{

      },
      "footer_links":[],
      "footer_active_id":null,
      footer_active_load:false,
      'current_checking_url':'',
    }
  },
  metaInfo () {
    var app=this;
    var result={
      meta:[],
    };




    if(app.current_meta && app.current_meta.title && app.current_meta.title.length>0) {
      result.title=app.current_meta.title;

    }
    if(app.current_meta && app.current_meta.description && app.current_meta.description.length>0){
      result.meta.push( { vmid: 'description', name: 'description', content: app.current_meta.description });
    }

    if(app.current_meta && app.current_meta.image && app.current_meta.image.url>0){
      result.meta.push( { vmid: 'og:image', name: 'og:image', content: app.current_meta.image.url });
    }



    return result;
  },
  mounted: function () {

    var app=this;
    eventBus.$on("change_disable_footer_mobile",data=>{

      var app=this;

      app.footer_active_load=false;


    });
    eventBus.$on("change_subbar_mobile",data=>{
      console.log('call from footer',data);
      var app=this;
      app.footer_links=data.main_link.links;
      app.footer_active_id=data.link_id;
      app.footer_active_load=true;


    });
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
    this.windowWidth=window.innerWidth;

    //this.subbar_active_link_href=this.$route.path;


    if(this.$route.name=="login"){
      this.nextURLAfterRedirect="/";
    }else {
      this.nextURLAfterRedirect=this.$route.fullPath;
    }
    this.url_logotype=Vue.config.URL_LOGOTYPE;
    this.url_logotype_dark=Vue.config.URL_LOGOTYPE_DARK;
    var current_theme="day_mode";
    // if(localStorage.getItem("theme_mode")){
    //   current_theme=localStorage.getItem("theme_mode");
    // }else if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    //   current_theme="night_mode";
    // }
    //this.current_theme=current_theme;

    eventBus.$on("theme_is_changed",data=>{
      var theme=data.theme;

      app.current_theme=theme;

    });

    eventBus.$on("update_mainbar",data=>{
      app.islogin=data.islogin;
      app.user=data.user;

      app.firstLoad();
    });


    if(this.$route.meta.typebar){

      // this.typebar=this.$route.meta.typebar;
    }else {
      this.typebar='';
    }





    if(this.$route.query && this.$route.query.nextUrl && this.$route.query.nextUrl.length>0){

      //this.addProject(false);
    }




    this.random_code = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);

    app.cart=Api.getCart();


    Api.syncCart();

    eventBus.$on("sync_cart",cart=>{
      app.cart=cart;
      app.total_cart_price=cart.length;
    });
    eventBus.$on("telegram_login",data=>{
      app.addProject(false);
    });








    var tmpUser = UserModel.get();


    if(tmpUser && tmpUser.api_token) {

      //app.updateNotifyCount();
      //  app.timer = setInterval(app.updateNotifyCount, 20000);


      if(this.$route.query && this.$route.query.nextUrl && this.$route.query.nextUrl.length>3){
        //app.$router.push(app.$route.query.nextUrl);
        //var rand_string=Math.ceil(Math.random()*10);
        document.location.href=this.$route.query.nextUrl;
      }

      this.islogin = true;
      this.user = tmpUser;


      // app.timer = setInterval(app.updateNotifyCount, 2000);

      if (app.islogin == true && app.user.islead == 1) {
        Api.loadFunnels(function (datas) {
          if (datas.funnels.length > 0) {
            app.funnels = datas.funnels;
          }
        })
      }
    }

    this.firstLoad();





    // let tg_widget = document.createElement('script');
    // tg_widget.setAttribute("src", "https://telegram.org/js/telegram-widget.js?14");
    // tg_widget.setAttribute("data-telegram-login", "Noibizcombot");
    // tg_widget.setAttribute("data-size", "small");
    // tg_widget.setAttribute("data-request-access", "write");
    // //tg_widget.setAttribute("data-onauth", "this.telegramLoginCallback(user)");
    // tg_widget.setAttribute("data-auth-url", "http://1aaa54bb86e2.ngrok.io/#/onlogin");
    // tg_widget.setAttribute("async", "");
    //
    // this.$refs.telegram_login.appendChild(tg_widget);
  },
  methods: {
    openHome(){
      this.$router.push({"path":"/"});
    },
    isLoginPage(){
      var app=this;
      if(app.$route.name=="login"){
        return true;
      }else {
        return false;
      }
    },
    isSettigPage(){
      var app=this;
      var current_active_link=app.$route.path;
      if(( current_active_link=="/rewards"  ||  (current_active_link.includes("/invoice")) || (current_active_link.includes("/rewards") && !current_active_link.includes("/id"))  || current_active_link.includes("/notif") || current_active_link.includes("/shop/my/") || current_active_link.includes("/portfolio/add") || current_active_link.includes("/portfolio/edit") || current_active_link.includes("/setup") || (current_active_link.includes("/invoices") && !current_active_link.includes("/project/"))) ){
        return true;
      }else {
        return false;
      }
    },
    getLoginLink(){
      var app=this;
      var link_login="/login";
      if(app.$route.name!="login" && app.$route.name!="wait_activate"){
        link_login="/login?nextUrl="+app.$route.fullPath;
      }
      return link_login;
    },
    insertMainLinks(main_links){
      var app=this;
      if(app.islogin){
        var newLink={
          id:'setup',
          title:'настройки',
          type:'/setup',
          alt:'настройки',
          icon:'<i class="fa fa-cog"></i>',
          links:[]

        };
        main_links.push(newLink);
      }else {
        var link_login="/login";
        if(app.$route.name!="login" && app.$route.name!="wait_activate"){
            link_login="/login?nextUrl="+app.$route.fullPath;
        }

        var newLink={
          id:'login',
          title:'войти',
          type:link_login,
          alt:'войти',
          icon:'<i class="fa fa-user"></i>',
          links:[]

        };
        main_links.push(newLink);

      }

      return main_links;
    },
    insertCartLink(main_links){
      let insertIndex = Math.floor(main_links.length / 2);
      var cart_element= {


        "title": "Корзина",
        "type": "/cart",
        "alt": "Корзина",
        "icon": '<i class="ni ni-cart"></i>'
      };
      main_links.splice(insertIndex, 0, cart_element);
      return main_links;
    },
    firstLoad(){
      var app=this;
      var current_url=new URL(this.$route.fullPath, window.location.origin).href;


      //alert(this.$route.fullPath);

      console.log('windowWIdth is '+this.windowWidth);
      if(this.windowWidth>=768) {

        Api.loadAboutGetConfWithUrl(current_url, function (data) {
          app.title_site    = 'Сайт';
          app.current_meta  = data.current_meta;
          app.main_links    = data.links;
          app.ismarketplace=data.ismarketplace;
          if(app.ismarketplace){
            app.main_links=app.insertCartLink(data.links);
          }else {
            app.main_links=data.links;
          }
          app.main_links=app.insertMainLinks(app.main_links);

          if (app.main_links.length > 0) {

            if (app.$route.meta.typebar) {

              app.findlinkByTypebar(app.$route.meta.typebar)
              // this.typebar=this.$route.meta.typebar;
            }

            app.reparceActiveLink(app.$route.path);

            if (app.typebar && app.typebar.length > 0) {
              localStorage.setItem("current_active_link", app.subbar_active_link_href);
              localStorage.setItem("current_typebar", app.typebar);

            }



            if (!(app.subbar_active_link_href && app.subbar_active_link_href.length > 1 && app.typebar && app.typebar.length > 1)) {
              // if (localStorage.getItem('current_typebar')) {
              //   var tmp_current_active_link = localStorage.getItem("current_active_link");
              //   var tmp_current_typebar     = localStorage.getItem("current_typebar");
              //   if (tmp_current_typebar && tmp_current_typebar.length > 0) {
              //     app.subbar_active_link_href = tmp_current_active_link;
              //     app.typebar                 = tmp_current_typebar;
              //     if (tmp_current_active_link.length > 0) {
              //       app.reparceActiveLink(tmp_current_active_link);
              //     } else {
              //
              //       app.typebar = tmp_current_typebar;
              //
              //     }
              //
              //   }
              // }
            }

          }

          if (data.about && data.about.title) {
            app.slogans    = data.about.slogans;
            app.title_site = data.about.title;

            // document.title=data.about.title;
          }

          app.pages_categorys = data.pages_categorys;
          app.is_load         = true;
          app.updateNotifyCount();
        });
      }else {

        app.is_load_mobile=true;
        app.updateNotifyCount();
      }
    },
    onResize() {
      this.windowWidth=window.innerWidth;
    },
    findlinkByTypebar(current_typebar){
      var app=this;
      if(app.main_links.length>0){
        app.main_links.forEach(function(elem,index){
          if(elem.type=="/posts" && current_typebar=='blog'){
            app.typebar="link_"+elem.id;
          }

          if(elem.links && elem.links.length>0){

            elem.links.forEach(function(subelem,index){


              if(subelem.type=="/posts" && current_typebar=="blog"){
                app.typebar="link_"+elem.id;
                app.subbar_active_link=subelem.id;
                app.subbar_active_link_href=subelem.type;

              }
            });

          }
        });


      }
    },
    reparceActiveLink(current_active_link){


      // console.log('reparce activeLink',{"currentLink":current_active_link});
      // localStorage.setItem("reparce_activeLink_"+current_active_link,true);

      var app=this;

      if(app.current_checking_url==current_active_link){
        return false;
      }

      app.current_checking_url=current_active_link;

      if(app.main_links.length>0){
        app.main_links.forEach(function(elem,index){

          if(elem.type==current_active_link){
            app.typebar="link_"+elem.id;
          }
          if(elem.type=="/services" && (current_active_link.includes("/service/") && !current_active_link.includes("/id") ) ){
            app.typebar="link_"+elem.id;
          }
          if(elem.type=="/works" && current_active_link.includes("/works")){
            app.typebar="link_"+elem.id;
          }
          if(elem.type=="/posts" && current_active_link.includes("/post/")){
            app.typebar="link_"+elem.id;
          }

          if(elem.type=="/setup" && ( current_active_link=="/rewards"  ||  (current_active_link.includes("/invoice")) || (current_active_link.includes("/rewards") && !current_active_link.includes("/id"))  || current_active_link.includes("/notif") || current_active_link.includes("/shop/my/") || current_active_link.includes("/portfolio/add") || current_active_link.includes("/portfolio/edit") || current_active_link.includes("/setup") || (current_active_link.includes("/invoices") && !current_active_link.includes("/project/"))) ){
            app.typebar="link_"+elem.id;
          }
          if(elem.links && elem.links.length>0){

            elem.links.forEach(function(subelem,index){


              if(subelem.type==current_active_link){
                app.typebar="link_"+elem.id;
                app.subbar_active_link=subelem.id;
                app.subbar_active_link_href=subelem.type;

              }else if(subelem.type=="/services" && (current_active_link.includes("/service/") && !current_active_link.includes("/id")) ){
                app.typebar="link_"+elem.id;
                app.subbar_active_link=subelem.id;
                app.subbar_active_link_href=subelem.type;
              }else if(subelem.type=="/works" && current_active_link.includes("/works")){
                app.typebar="link_"+elem.id;
                app.subbar_active_link=subelem.id;
                app.subbar_active_link_href=subelem.type;
              }else if(subelem.type=="/posts" && current_active_link.includes("/post/")){
                app.typebar="link_"+elem.id;
                app.subbar_active_link=subelem.id;
                app.subbar_active_link_href=subelem.type;
              }
            });

          }
        });


      }

    },
    openSubMenuLink(link){
      this.subbar_active_link_href=link;

    },
    changeSubLink(sublink_path){
      var app=this;
      if(app.main_links.length>0){

        app.main_links.forEach(function(elem,index){
          if(elem.type==sublink_path){
            app.typebar="link_"+elem.id;
          }
          if(elem.type=="/services" && (sublink_path.includes("/service/") &&  !sublink_path.includes("/id")) ){
            app.typebar="link_"+elem.id;
          }
          if(elem.type=="/works" && sublink_path.includes("/works")){
            app.typebar="link_"+elem.id;
          }
          if(elem.links && elem.links.length>0){

            elem.links.forEach(function(subelem,index){


              if(subelem.type==sublink_path){
                app.typebar="link_"+elem.id;
                app.subbar_active_link=subelem.id;
                app.subbar_active_link_href=subelem.type;
              }else if(subelem.type=="/services" && (sublink_path.includes("/service/") && !sublink_path.includes("/id")) ){
                app.typebar="link_"+elem.id;
                app.subbar_active_link=subelem.id;
                app.subbar_active_link_href=subelem.type;
              }else if(subelem.type=="/works" && sublink_path.includes("/works")){
                app.typebar="link_"+elem.id;
                app.subbar_active_link=subelem.id;
                app.subbar_active_link_href=subelem.type;
              }
            });

          }
        });

      }
    },
    closeAfterLogin(){
      var app=this;
      app.is_show_after_login=false;
      return false;
    },
    changeTheme() {
      eventBus.$emit("changeTheme");

    },
    changeSubbar(typebar,index) {
      var current_link=this.main_links[index];

      if(current_link.links && current_link.links.length>0){
       // this.typebar=typebar;
        this.$router.push(current_link.links[0].type);

      }else {
        this.typebar=typebar;

        this.$router.push(current_link.type);
      }

    },
    async updateJobNotifyCount(){
      var app = this;

      // if(!app.is_load){
      //   return false;
      // }
      if(app.islogin==false){
        return false;
      }


      try{
        Api.loadNotifyCount(function (notifys) {


          app.notify_count = notifys.count;
          app.notify_count_invoices=notifys.count_invoices;
          app.notify_count_tasks=notifys.count_tasks;
          var total_count=app.notify_count+app.notify_count_invoices;
          app.total_count=total_count;

          var emit_params={};
          emit_params.notify_count=app.notify_count;
          emit_params.notify_count_invoices=app.notify_count_invoices;
          emit_params.notify_count_tasks=app.notify_count_tasks;
          eventBus.$emit("update_notify_count",emit_params)



        });
      } catch(e){

      }
    },
    async updateNotifyCount() {

      var app = this;

      // if(!app.is_load && !app.is_load_mobile){
      //   return false;
      // }





      if(app.islogin==false){
        console.log('fail login');
        return false;
      }
      {
        if (app.update_notify_interval) {
          clearInterval(app.update_notify_interval)
        }
      }


      app.updateJobNotifyCount();
      app.update_notify_interval=setInterval(app.updateJobNotifyCount,5000)




    },
  }
};
</script>
<style>
</style>